module.exports = __webpack_public_path__ + "static/media/avc_top_progress_bg.7ee14e94.png";